import { GuidService } from 'ui-components/services/guid-service';
import * as BulkUpdateActions from '../../../store/bulk/update/bulk.update.actions';
import { BulkActions } from '../../../enums/bulk-actions';

export const AddTaxIdentifiers = {
  id: 'add-tax-identifiers',
  name: BulkActions.addTaxIdentifiers.message,

  makeHandler: (dispatch, bulkUpdateTypeData) => {
    return (ids, filters) =>
      dispatch(
        BulkUpdateActions.startBulkUpdateJob(bulkUpdateTypeData, [BulkActions.addTaxIdentifiers], ids, GuidService.newGuid(), filters),
      );
  },
};
